import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../auth.service";

@Component({
	selector: 'noaccess',
	template: `
		<h1>
			Access denied! - 403 error!
		</h1>
	
		May be, you need
	
		<a
			*ngIf="authService.isAuth; else login"
			routerLink="/sign_out"
		>
			relogin
		</a>
		for access
	
		<ng-template #login>
			<a
				class="btn btn-primary"
				routerLink="/sign_in"
				role="button"
			>
				login
	        </a>
	</ng-template>
	`
})
export class NoAccessComponent implements OnInit {
	constructor(
		public authService: AuthService,
		public router: Router,
	) {}


	async ngOnInit() {
		const me = this;
		
		await me.authService.fetch();
		
		if ( ! this.authService.isAuth) {
			return me.router.navigate(['/sign_in']); 
		}
	}
}
